// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const blocks = document.querySelectorAll('.wp-block-colisee-people-list');

if (blocks && (window.innerWidth < 720)) {
  blocks.forEach(function(block, index) {
    block.querySelector('.swiper').classList.add('swiper-people-' + index);

    const swiper = new Swiper('.swiper-people-' + index, {
      // configure Swiper to use modules
      modules: [Navigation, Pagination],
  
      loop: true,
      slidesPerView: 'auto',
  
      keyboardControl: true,
      grabCursor: true,
  
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });
}